import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch} from 'react-router-dom';
import membGrade from './views/membGrade';
import club from './views/club';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const MainRoute = () => (
  <HashRouter>
      <Switch>
          <Route path="/" component={club}/>
      </Switch>
  </HashRouter>
);

ReactDOM.render(<MainRoute/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
